import {
  PAGE_API_LOADING
} from '../mutation-types'

const state = {
  requestCount: 0
}

const getters = {
  isLoading: (state) => state.requestCount > 0
}

const mutations = {
  [PAGE_API_LOADING] (state, status) {
    if (status === -1) {
      state.requestCount = 0
    } else if (status) {
      state.requestCount++
    } else if (state.requestCount > 0) {
      state.requestCount--
    }
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/pageState.js